class CountdownTimer extends HTMLElement {
  constructor() {
    super();

    this.timerStartYear = this.getAttribute('data-timer-start-year');
    this.timerStartMonth = this.getAttribute('data-timer-start-month');
    this.timerStartDay = this.getAttribute('data-timer-start-day');
    this.timerStartHour = this.getAttribute('data-timer-start-hour');
    const startDate = new Date(this.timerStartYear, this.timerStartMonth - 1, this.timerStartDay, this.timerStartHour);

    this.timerEndYear = this.getAttribute('data-timer-end-year');
    this.timerEndMonth = this.getAttribute('data-timer-end-month');
    this.timerEndDay = this.getAttribute('data-timer-end-day');
    this.timerEndHour = this.getAttribute('data-timer-end-hour');
    const endDate = new Date(this.timerEndYear, this.timerEndMonth - 1, this.timerEndDay, this.timerEndHour);

    const now = new Date();

    if (startDate > now || endDate < now)
      return;

    const containerEl = document.getElementById(this.getAttribute('data-container-id'));
    if (!containerEl) return;

    containerEl.style.display = 'block';

    this.timerStartInterval = setInterval(() => {
      this.remainingTime = this.calculateRemainingTime();
      this.updateTimer();
    }, 1000);
  }

  calculateRemainingTime() {
    const now = new Date();
    const endDate = new Date(this.timerEndYear, this.timerEndMonth - 1, this.timerEndDay, this.timerEndHour);
    return endDate - now;
  }

  updateTimer() {
    const days = Math.floor(this.remainingTime / (1000 * 60 * 60 * 24));
    const hours = Math.floor((this.remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((this.remainingTime % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((this.remainingTime % (1000 * 60)) / 1000);

    if (days <= 0 && hours <= 0 && minutes <= 0 && seconds <= 0) {
      this.disableTimer();
      return;
    }

    const daysEl = this.querySelector('.keetsa-countdown-timer__days-value');
    const hoursEl = this.querySelector('.keetsa-countdown-timer__hours-value');
    const minutesEl = this.querySelector('.keetsa-countdown-timer__minutes-value');
    const secondsEl = this.querySelector('.keetsa-countdown-timer__seconds-value');

    if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

    daysEl.textContent = days;
    hoursEl.textContent = hours;
    minutesEl.textContent = minutes;
    secondsEl.textContent = seconds;

    this.announceTimeRemaining(days, hours, minutes);
  }

  announceTimeRemaining(days, hours, minutes) {
    if (!this.statusEl) {
      this.statusEl = this.querySelector('.keetsa-countdown-timer__status');
    }
    if (!this.statusEl) return;

    if (!this.unitLabels) {
      const daysLabel = this.querySelector('.keetsa-countdown-timer__days-label');
      const hoursLabel = this.querySelector('.keetsa-countdown-timer__hours-label');
      const minutesLabel = this.querySelector('.keetsa-countdown-timer__minutes-label');
      this.unitLabels = {
        days: daysLabel ? daysLabel.textContent.trim() : 'days',
        hours: hoursLabel ? hoursLabel.textContent.trim() : 'hours',
        minutes: minutesLabel ? minutesLabel.textContent.trim() : 'minutes',
      };
    }

    const announcement =
      days + ' ' + this.unitLabels.days + ', ' +
      hours + ' ' + this.unitLabels.hours + ', ' +
      minutes + ' ' + this.unitLabels.minutes;

    if (announcement !== this.lastAnnouncement) {
      this.lastAnnouncement = announcement;
      this.statusEl.textContent = announcement;
    }
  }

  disconnectedCallback() {
    if (this.timerStartInterval) {
      clearInterval(this.timerStartInterval);
    }
  }

  disableTimer() {
    
    if (this.timerStartInterval) {
      clearInterval(this.timerStartInterval);
    }

    const containerEl = document.getElementById(this.getAttribute('data-container-id'));
    if (!containerEl) return;
    containerEl.style.display = 'none';

    const daysEl = this.querySelector('.keetsa-countdown-timer__days-value');
    const hoursEl = this.querySelector('.keetsa-countdown-timer__hours-value');
    const minutesEl = this.querySelector('.keetsa-countdown-timer__minutes-value');
    const secondsEl = this.querySelector('.keetsa-countdown-timer__seconds-value');

    if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

    daysEl.textContent = "0";
    hoursEl.textContent = "0";
    minutesEl.textContent = "0";
    secondsEl.textContent = "0";
  }

}

customElements.define('countdown-timer', CountdownTimer);
